var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import markdownDatasets from "../markdownDatasets";
import PagesContext from "./Context";
import { objectPath } from "../utils";

export class ValueComponent extends Component {
  renderChildren(_value) {
    const { path } = this.props;
    return path ? objectPath(path, _value) : _value;
  }

  render() {
    const { property, value } = this.props;
    return property ?
    this.renderChildren(value) : /*#__PURE__*/

    _jsx(PagesContext.Consumer, {}, void 0, (val) => this.renderChildren(val));

  }
}

ValueComponent.defaultProps = {
  value: '-',
  path: '',
  property: ''
};







export const mapStateToProps = (state, props) =>
props.property ? { value: markdownDatasets.getMetadataValue(state, props) } : {};

export default connect(mapStateToProps)(ValueComponent);